import { Link } from "react-router-dom";
import { heroData } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20modern%20home%20theater%20with%20large%20projection%20screen%2C%20warm%20ambient%20golden%20and%20deep%20amber%20lighting%2C%20cozy%20velvet%20seating%2C%20dramatic%20cinematic%20atmosphere%2C%20dark%20rich%20tones%2C%20professional%20photography%2C%20clean%20composition&width=1600&height=800&seq=hero-bg-main&orientation=landscape)`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/70"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px]">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-sparkling-line mr-1"></i>无需下载 · 即点即播
          </span>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
            {heroData.title}
          </h2>
          <p className="text-base md:text-lg text-white/85 leading-relaxed mb-8 max-w-[560px]">
            {heroData.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <Link
              to={heroData.ctaLink}
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-base hover:bg-primary-400 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-fill mr-2 text-lg"></i>{heroData.ctaText}
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white rounded-full font-medium text-base hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-information-line mr-2"></i>了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-2 text-white/50 text-xs">
          <span>向下滚动探索</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}